var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"image",style:({ width: _vm.size, height: _vm.height }),attrs:{"src":_vm.publicPath + 'assets/' + _vm.src,"alt":_vm.alt ? _vm.alt : 'icon'}})
}
var staticRenderFns = []

export { render, staticRenderFns }